import { render } from "./Medical.vue?vue&type=template&id=3a7f86ea"
import script from "./Medical.vue?vue&type=script&lang=js"
export * from "./Medical.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__